import { ExternalClientAppType } from 'types'

export function getExternalClientTypeText(type: ExternalClientAppType) {
  switch (type) {
    case 'm2m':
      return 'Machine to Machine'
    case 'web':
      return 'Web Application'
  }
}
